export interface CampaignData {
  is_enabled: boolean;
  status: string;
  updated: string;
  open_rate: number;
  hidden_for_partners: any[];
  events_count: number;
  emails_delivered: number;
  created: string;
  campaign_id: string;
  campaign_focus: string;
  is_editable: boolean;
  created_user: string;
  accounts_count: number;
  click_through_rate: number;
  has_automations: boolean;
  parent_campaign_id: string;
  active_accounts_count: number;
  is_hidden: boolean;
  is_draft: boolean;
  updated_user: string;
  name: string;
  campaign_schedule: CampaignStepInterface[];
  partner_id: string;
  market_id: string;
  campaign_schedule_version: number;
  locale: string;
  email_category_id: string;
  is_premade: boolean;
}

export interface CampaignPreviewInterface {
  html: string;
  name: string;
  subject: string;
}

export interface CampaignStepInterface {
  campaign_step_id: string;
  step_type: string;
  template_id: string;
  seconds_after_last_email: number;
  name: string;
}

export interface TemplateData {
  created: string;
  fullHtml: string;
  htmlBody: string;
  name: string;
  subject: string;
  templateId: string;
  useFullHtml: boolean;
}

export interface CampaignStepData {
  bounced: number;
  campaign_step_id: string;
  clickedThrough: number;
  created: number;
  delivered: number;
  dropped: number;
  notRequired: number;
  onDeck: number;
  opened: number;
  paused: number;
  pending: number;
  refreshed: number;
  sent: number;
  spamReport: number;
  unsubscribed: number;
  clickToOpenRate: number;
  openRate: number;
}

export interface CampaignStats {
  active: number;
  clicked_through: number;
  completed: number;
  delivered: number;
  opened: number;
  sent: number;
  stopped: number;
  total_accounts: number;
  total_leads: number;
  total_recipients: number;
  undeliverable: number;
  waiting_on_rate_limit: number;
}

export enum CampaignStatus {
  ACTIVE = 'active',
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export interface StepNumberInterface {
  currentStep: number;
  totalSteps: number;
}

export interface MarketingAutomationPageData {
  key: string;
  title: string;
  imageHeader: {
    title: string;
    subtitle: string;
  };
  showNewPage?: boolean;
  manageTagsCampaignId?: string;
}

export enum CampaignFocus {
  ACQUIRE = 'acquire',
  ADOPT = 'adopt',
  UPSELL = 'upsell',
}
